import { Typography } from '@mui/material';
import { FC } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { NavLink } from 'react-router';
import { useTranslation } from 'react-i18next';

export const CreateNewAd: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="basis-1/4 p-4">
      <NavLink
        to="/client/create/ad"
        className="bg-white shadow-sm h-48 flex flex-col items-center justify-center flex-center rounded-[10px] 
      border-dashed border-2 border-[#00aa96] p-2 text-[#00aa96] hover:scale-95 transition-transform duration-200"
      >
        <AddIcon className="mr-1" />
        <Typography variant="h6" color="inherit">
          {t('ads.create_ad_text')}
        </Typography>
      </NavLink>
    </div>
  );
};
